(function(){
  'use strict';

  var scheduled=false;

  function getPrioritySections(){
    var main=document.querySelector('main[data-template]');
    var template=main&&main.getAttribute('data-template')||'';
    var count=template==='index' ? 1 : 2;
    return Array.prototype.slice.call(document.querySelectorAll('main .shopify-section')).slice(0,count);
  }

  function isHeroElement(element){
    return !!element.closest(
      '[data-ab-hero], [data-hero], .banner, .image-banner, ' +
      '[class*="hero"], [class*="Hero"], [class*="banner"], [class*="Banner"]'
    );
  }

  function isPriorityImage(img, prioritySections){
    if(img.hasAttribute('data-ab-priority') || img.closest('[data-ab-priority]')) return true;
    var loading=String(img.getAttribute('loading')||'').toLowerCase();
    var fetchPriority=String(img.getAttribute('fetchpriority')||'').toLowerCase();
    if(loading==='eager' || fetchPriority==='high') return true;
    if(img.closest('header, .announcement-bar, .announcement-bar-section')) return true;
    if(isHeroElement(img)) return true;
    return prioritySections.some(function(section){return section.contains(img);});
  }

  function applyLazyLoading(){
    var prioritySections=getPrioritySections();

    document.querySelectorAll('img').forEach(function(img){
      if(isPriorityImage(img,prioritySections)) return;
      img.setAttribute('loading','lazy');
      img.setAttribute('decoding','async');
      img.setAttribute('fetchpriority','low');
    });

    document.querySelectorAll('iframe, video').forEach(function(media){
      if(media.hasAttribute('data-ab-priority') || media.closest('[data-ab-priority]') || isHeroElement(media)) return;
      if(media.tagName==='IFRAME') media.setAttribute('loading','lazy');
      if(media.tagName==='VIDEO') media.setAttribute('preload','none');
    });

    document.querySelectorAll('main .shopify-section').forEach(function(section,index){
      var isPrioritySection=prioritySections.indexOf(section)!==-1;
      var containsHero=!!section.querySelector(
        '[data-ab-hero], [data-hero], .banner, .image-banner, ' +
        '[class*="hero"], [class*="Hero"], [class*="banner"], [class*="Banner"]'
      );
      if(index>0 && !isPrioritySection && !containsHero){
        section.style.contentVisibility='auto';
        section.style.containIntrinsicSize='800px';
      }else{
        section.style.contentVisibility='';
        section.style.containIntrinsicSize='';
      }
    });
  }

  function schedule(){
    if(scheduled) return;
    scheduled=true;
    var run=function(){scheduled=false;applyLazyLoading();};
    if(window.requestIdleCallback) window.requestIdleCallback(run,{timeout:1200});
    else window.setTimeout(run,700);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
})();